import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M22.728 22.73a.914.914 0 0 1-1.296 0l-5.47-5.47a9.12 9.12 0 0 1-5.795 2.074c-5.053 0-9.165-4.111-9.165-9.164 0-5.054 4.112-9.165 9.165-9.165a9.17 9.17 0 0 1 4.583 1.226.916.916 0 1 1-.918 1.588 7.3 7.3 0 0 0-3.665-.98c-4.043 0-7.332 3.288-7.332 7.33 0 1.07.236 2.084.65 3l3.482-4.177a1.856 1.856 0 0 1 2.736-.124l1.767 1.767 8.078-9.318a.917.917 0 0 1 1.388 1.199l-8.047 9.316a1.86 1.86 0 0 1-1.336.641 1.89 1.89 0 0 1-1.379-.542l-1.767-1.767-3.907 4.65a7.32 7.32 0 0 0 5.667 2.686c4.042 0 7.331-3.289 7.331-7.331q0-.207-.012-.41a.92.92 0 0 1 .867-.964.913.913 0 0 1 .964.866q.015.252.014.507a9.12 9.12 0 0 1-2.073 5.795l5.47 5.47a.916.916 0 0 1 0 1.296z"
    }, null, -1)
  ]))]))
}
export default { render: render }